<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-8">
            <h4 class="fw-bold">
              Taxation - {{commonService.headerName}}
            </h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-4 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">
              Close Accounts
            </button>
          </div>
        </div>
      </div>
      <hr />
      <form [formGroup]="CreateTaxationFormGroup">
        <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">
          <div class="row">
            <div class="col-12">
              <!--<h5 class="fw-bolder font-size-16">
                Taxation
              </h5>-->
              <p class="text-dark">Please enter notes on taxation in the field below.</p>
              <p class="text-dark">If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xxl-11 col-xl-12 col-md-12 col-lg-12 col-sm-12 pb-3 p-md-2 p-0">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600"></label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="mb-2 text-center">
                              <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                              <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="mb-2 text-center">
                              <h6 class="mb-0 fw-bolder">{{commonService.LastYear}}</h6>
                              <label>({{commonService.StartdateLastAP}} to {{commonService.LYAccountingPeriod}})</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 p-0 p-lg-5">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">UK Corporation Tax</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11" formControlName="TotalCurrentTaxExpenseCredit" placeholder="" (blur)="Calculations()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" [appTooltip]="showBubbledata" appNumberdirective maxlength="11" formControlName="TotalCurrentTaxExpenseCredit_LY" placeholder="" (blur)="Calculations()" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Deferred Tax</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end MinusValue" [appTooltip]="showBubbledata" appNumberdirective maxlength="11" formControlName="TotalDeferredTaxExpenseCredit" placeholder="" (blur)="Calculations()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end MinusValue" [appTooltip]="showBubbledata" appNumberdirective maxlength="11" formControlName="TotalDeferredTaxExpenseCredit_LY" placeholder="" (blur)="Calculations()" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="col-xxl-4 col-xl-4 col-md-12 col-lg-12 col-sm-12 col-12">
                        <label class="m-t-5 font-weight-600">Tax on profit on ordinary activities</label>
                      </div>
                      <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="row">
                          <div [ngClass]="commonService.showControl? 'col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6':'col-xxl-9 col-xl-10 col-lg-10 col-md-11 col-sm-12 col-12'">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" appNumberdirective maxlength="11" formControlName="TaxOnProfitOrLossOnOrdinaryActivities" placeholder="" (blur)="Calculations()" />
                            </div>
                          </div>
                          <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" *ngIf="commonService.showControl==true">
                            <div class="input-group mb-3">
                              <div class="input-group-text">
                                <span class=" theme-color font-weight-600">£</span>
                              </div>
                              <input type="text" class="form-control text-end AccountNumber" appNumberdirective maxlength="11" formControlName="TaxTaxCreditOnProfitOrLossOnOrdinaryActivities_LY" placeholder="" (blur)="Calculations()" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--<div class="row">
                     <div class="col-12 col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                       <div class="mb-5">

                       </div>
                       <div class="mb-4">
                         <label>UK Corporation Tax</label>
                       </div>
                       <div class="mb-4">
                         <label>Deferred Tax</label>
                       </div>
                       <div class="mb-4">
                         <label>Tax on profit on ordinary activities</label>
                       </div>
                     </div>
                     <div class="col-12 col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                       <div class="mb-2 text-center">
                         <h6 class="mb-0 fw-bolder">{{commonService.StartYear}}</h6>
                         <label>({{commonService.CAPeriodFrom}} to {{commonService.CAPeriodTo}})</label>
                       </div>
                       <div class="mb-2">
                         <div class="input-group">
                           <div class="input-group-text ">£</div>
                           <input type="text" class="form-control AccountNumber" appNumberdirective formControlName="TotalCurrentTaxExpenseCredit" placeholder="" (change)="Calculations()" />
                         </div>
                       </div>
                       <div class="mb-2">
                         <div class="input-group">
                           <div class="input-group-text ">£</div>
                           <input type="text" class="form-control AccountNumber" appNumberdirective formControlName="TotalDeferredTaxExpenseCredit" placeholder="" (change)="Calculations()" />
                         </div>
                       </div>
                       <div class="mb-2">
                         <div class="input-group">
                           <div class="input-group-text ">£</div>
                           <input type="text" class="form-control AccountNumber" appNumberdirective formControlName="TaxOnProfitOrLossOnOrdinaryActivities" placeholder="" (change)="Calculations()" />
                         </div>
                       </div>
                     </div>
                     <div class="col-12 col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12" *ngIf="commonService.showControl==true">
                       <div class="mb-2 text-center">
                         <h6 class="mb-0 fw-bolder">{{commonService.LastYear}}</h6>
                         <label>({{commonService.StartdateLastAP}} to {{commonService.LYAccountingPeriod}})</label>
                       </div>
                       <div class="mb-2">
                         <div class="input-group">
                           <div class="input-group-text ">£</div>
                           <input type="text" class="form-control AccountNumber" appNumberdirective formControlName="TotalCurrentTaxExpenseCredit_LY" placeholder="" (change)="Calculations()" />
                         </div>
                       </div>
                       <div class="mb-2">
                         <div class="input-group">
                           <div class="input-group-text ">£</div>
                           <input type="text" class="form-control AccountNumber" appNumberdirective formControlName="TotalDeferredTaxExpenseCredit_LY" placeholder="" (change)="Calculations()" />
                         </div>
                       </div>
                       <div class="mb-2">
                         <div class="input-group">
                           <div class="input-group-text ">£</div>
                           <input type="text" class="form-control AccountNumber" appNumberdirective formControlName="TaxTaxCreditOnProfitOrLossOnOrdinaryActivities_LY" placeholder="" (change)="Calculations()" />
                         </div>
                       </div>
                     </div>

                     </div>-->
                </div>
              </div>
            </div>
            <hr />
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12 mt-3 ">
              <div class="row">
                <div class="col-12 mb-3">
                  <p class="text-dark">
                    Please provide any additional information on factors affecting the tax charge that you may need to report,
                    for example, adjustments, accrued capital allowances, rounding etc. Please enter a description in the item
                    field below and the corresponding value in the relevant year field(s).
                  </p>
                </div>
                <div class="col-12 text-end">
                  <button style="" class="btn themedefault mt-2 p-1 ps-3 pe-3 me-0 " type="button" (click)="AddNew()" [disabled]="disableTaxation">+ Add New</button>
                </div>
                <div class="col-12 mb-3" formArrayName="WizardList">
                  <div class="table-responsive">
                    <table class="tableheading table dataTable table-bordered table-striped row-border table-hover pt-10" style="white-space:nowrap !important;">
                      <thead>
                        <tr>
                          <th>Item Description</th>
                          <th>{{commonService.StartYear}}</th>
                          <th class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let list of ListCreateTaxationFormGroupGrid.controls;let i=index" [formGroupName]="i">
                          <td>
                            <input type="text" class="form-control string caseSenstive" [disabled]="disableTaxation" appNumberdirective maxlength="100" formControlName="Description" [ngClass]="{ 'is-invalid':(!valid && (ListCreateTaxationFormGroupGrid.controls.length > 0) && (ListCreateTaxationFormGroupGrid.controls[i].value['Description'] == ''))}" />
                            <span class="text-danger" *ngIf="(!valid && (ListCreateTaxationFormGroupGrid.controls.length > 0) && (ListCreateTaxationFormGroupGrid.controls[i].value['Description'] == ''))">Item Description is required</span>
                          </td>
                          <td><input type="text" class="form-control text-end MinusValue" [disabled]="disableTaxation" appNumberdirective formControlName="Total" (blur)="CalculationsGrid()" /></td>
                          <td align="center" class="cursor-pointer">
                            <button class="btn  btn-sm p-1" (click)="DeleteRow(i)" [disabled]="disableTaxation" title="Delete"><span class="fa fa-trash-can cantrash text-danger"></span></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                  <div class="row text-center mt-2" *ngIf="!ListCreateTaxationFormGroupGrid?.length">
                    <b class="mb-2">No records found</b>
                  </div>
                  <!--<div class="row" style="float:right;margin-top:2px;">
     <span style="display:contents;">Total</span>
     <input type="text" style="width: 300px; margin-left:45px;" class="form-control text-end AccountNumber" appNumberdirective maxlength="11" formControlName="CorporationTaxPayable" placeholder="" />
       <button style="width: 150px; margin-left: 20px;" class="btn themedefault p-1 ps-3 pe-3 " type="button" (click)="AddNew()">+ Add New</button>

     </div>-->
                </div>
                <div class="d-flex row justify-content-between ps-0" style="margin-top: 2px;" *ngIf="ListCreateTaxationFormGroupGrid?.length">
                  <div class="w-43 text-start text-lg-end mt-2 px-0">
                    <span style="display:contents;">Total</span>
                  </div>
                  <div class="w-46 px-0">
                    <div class="input-group mb-3">
                      <div class="input-group-text">
                        <span class=" theme-color font-weight-600">£</span>
                      </div>
                      <input type="text" style="" class="form-control text-end MinusValue" [appTooltip]="showBubbledata" [disabled]="disableTaxation" appNumberdirective maxlength="11" formControlName="CorporationTaxPayable" placeholder="" />
                    </div>
                  </div>
                  <div class="w-12"></div>
                </div>
                <div class="col-12">
                  <label>
                    Please enter any additional information in the field below.
                  </label>
                  <div class="mb-3">
                    <textarea class="form-control allowSpecialChars" appNumberdirective maxlength="4000" rows="6" [appTooltip]="showBubbledata" [disabled]="disableTaxation" required formControlName="DeferredTaxPolicy"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="On_Back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="On_Next()">Next</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
